import { Reveal } from "@/components/site/Reveal";

const BANNER = "https://customer-assets-agu9un31.emergentagent.net/job_timbodaking-media/artifacts/6jbk2asb_001.jpg";
const REEL = "https://www.instagram.com/reel/DN63kqUD1Q3/embed";

export default function StageZeroPage() {
  return (
    <div data-testid="stage-zero-page">
      {/* Hero */}
      <section className="relative min-h-[70vh] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img src={BANNER} alt="Stage Zero" className="w-full h-full object-cover" style={{ objectPosition: "center 30%" }} />
          <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/50 to-black/30" />
        </div>
        <div className="relative z-10 max-w-[1600px] mx-auto w-full px-6 md:px-12 pb-16 md:pb-24">
          <Reveal>
            <p className="overline text-gold mb-5">The AI King · Est. June 2025</p>
            <h1 className="headline text-6xl md:text-8xl lg:text-9xl text-white leading-[0.9]">Stage <span className="text-gold">Zero</span></h1>
            <p className="font-editorial italic text-2xl md:text-4xl text-white/85 mt-6 max-w-3xl">
              From super producer to super innovator.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Intro */}
      <section className="relative bg-obsidian py-20 md:py-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12 space-y-6 font-body text-white/65 text-lg leading-relaxed">
          <Reveal>
            <p>
              Few names carry as much weight in the evolution of modern music as Timbaland. Known for reshaping the
              sound of an era with his boundary-pushing production, Timbaland has built a career on staying ahead of
              the curve. Today he is once again leading from the front, this time at the intersection of music and
              artificial intelligence.
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <p>
              For Timbaland, AI is not a replacement for artistry; it is a catalyst. He sees the technology as a
              partner in creation, one that amplifies human imagination, accelerates workflows, and opens doors to
              possibilities that were once unimaginable. His passion lies in harnessing AI to extend the life of
              creativity, preserving iconic voices, expanding access to tools once reserved for high-end studios, and
              enabling artists to collaborate in new, transformative ways.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <blockquote className="border-l-2 border-gold pl-6 my-10">
              <p className="font-editorial italic text-2xl md:text-3xl text-white leading-snug">
                "AI can't replace the soul of music, but it can help us explore new dimensions of it."
              </p>
              <cite className="not-italic font-display uppercase tracking-[0.18em] text-[0.7rem] text-gold mt-4 block">
                Timbaland
              </cite>
            </blockquote>
          </Reveal>
          <Reveal delay={0.12}>
            <p>
              His goal is to build bridges between artistry and technology, ensuring that the future of music remains
              as emotionally resonant as it is innovative. By weaving AI into his creative process, Timbaland is
              shaping a landscape where technology and talent move in harmony, democratizing music creation and
              inspiring a new generation to think bigger.
            </p>
          </Reveal>
        </div>
      </section>

      {/* What is Stage Zero */}
      <section className="relative bg-[#0d0d0d] py-20 md:py-32 border-t border-white/10">
        <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 80% 20%, rgba(79, 176, 74,0.12), transparent 55%)" }} />
        <div className="relative z-10 max-w-[1100px] mx-auto px-6 md:px-12 text-center">
          <Reveal>
            <p className="overline text-gold mb-6">What Is Stage Zero</p>
            <h2 className="headline text-4xl md:text-6xl text-white mb-8">A new genre. A new kind of artist.</h2>
            <p className="font-body text-white/70 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto">
              Stage Zero is the artificial intelligence entertainment company founded by Timbaland in June 2025. The
              company is built around creating and managing digital <span className="text-gold">"A-pop"</span>{" "}
              (artificial pop) artists and content, treating AI as a creative force itself rather than just a production
              tool. Its first AI artist, <span className="text-gold">TaTa</span>, marks the first icon of a new cultural
              evolution.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-14 mx-auto max-w-[380px]">
              <div className="relative w-full overflow-hidden rounded-lg border border-white/10 bg-black" style={{ aspectRatio: "9 / 14" }}>
                <iframe
                  title="stage-zero-reel"
                  src={REEL}
                  className="absolute inset-0 w-full h-full"
                  frameBorder="0"
                  scrolling="no"
                  allowtransparency="true"
                  allow="encrypted-media"
                  data-testid="stage-zero-reel"
                />
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Closing quote */}
      <section className="relative bg-obsidian py-24 md:py-36 border-t border-white/10" data-testid="stage-zero-closing">
        <div className="absolute inset-0 pointer-events-none" aria-hidden style={{ background: "radial-gradient(circle at 50% 40%, rgba(79,176,74,0.10), transparent 60%)" }} />
        <div className="relative z-10 max-w-[1000px] mx-auto px-6 md:px-12 text-center">
          <Reveal>
            <blockquote className="font-editorial italic text-3xl md:text-5xl leading-[1.1] text-white">
              "The future isn't something you wait for. You build it, one sound at a time."
            </blockquote>
            <cite className="not-italic font-display uppercase tracking-[0.22em] text-xs text-gold mt-8 block">Timbaland</cite>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
